module.exports = __webpack_public_path__ + "static/combed-e5636d0c00d03ec35e67c30a4cb0f6a1.png";